import _sortBy from 'lodash/sortBy';

function getSelectedAttributes(selectedAttributes, field) {
  return {
    ...selectedAttributes,
    [field.objectKey]: {
      ...field,
      id: field.objectKey,
    },
  };
}

const isObjectKeyBlackListed = objectKey => {
  const blackList = {
    presence: true,
    assistants: true,
    directReports: true,
    assistantOf: true,
  };

  return blackList[objectKey];
};

export default function(configFields, siftBotFields) {
  const selectedAttributes = siftBotFields ? siftBotFields.reduce(getSelectedAttributes, {}) : {};
  const configFieldCollection = Object.keys(configFields).reduce((configFieldCollection, key) => {
    const configField = configFields[key];
    const field = configField
      ? {
          id: configField.objectKey,
          displayName: configField.displayName,
          objectKey: configField.objectKey,
          canOptOut: false,
        }
      : null;

    if (
      !configField.valueReadOnly &&
      !configField.objectKey.includes('.') &&
      !configField.fields &&
      !selectedAttributes[configField.objectKey] &&
      !isObjectKeyBlackListed(configField.objectKey) &&
      !configField.objectKey.includes('cf_page')
    ) {
      configFieldCollection.push(field);
    }

    return configFieldCollection;
  }, []);

  const sortedConfigFieldCollection = _sortBy(configFieldCollection, field => {
    return field.displayName.toLowerCase();
  });
  return sortedConfigFieldCollection;
}
